export default function roundNumberUp(n: number, factor: number = 10) {
  return Math.ceil(n / factor) * factor;
}
